import React, { useState, useEffect } from 'react';
import { CalendlyIcon } from '../../../assets';
import { useAppData } from '../../../context/AppContext';
import { useAuth } from '../../../context/AuthContext';
import {
  getUser,
  loginToCalendly,
  logoutFromCalendly,
} from '../../../core/requests/requests';
import { ConfirmModal, InfoModal } from '../../../components';

const CalendarHeader: React.FC = () => {
  const { setShowModalBackground } = useAppData();
  const { currentUser, setCurrentUser, authLogin } = useAuth();
  const accessToken = authLogin?.accessToken;
  const [showConfirmCalendlyLogoutModal, setShowConfirmCalendlyLogoutModal] =
    useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState<string>('');

  const fetchUserData = async () => {
    try {
      if (currentUser && accessToken) {
        const { data } = await getUser(currentUser?.id, accessToken);
        setCurrentUser(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleIntegrationToCalendly = async () => {
    try {
      const { data } = await loginToCalendly();
      if (data?.link) {
        window.open(data.link, '_blank');
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleCloseCalendlyLogoutModal = () => {
    setShowConfirmCalendlyLogoutModal(false);
    setShowModalBackground(false);
  };

  const handleOpenCalendlyLogoutModal = () => {
    setShowConfirmCalendlyLogoutModal(true);
    setShowModalBackground(true);
  };

  const handleCloseSuccessModal = () => {
    setShowModalBackground(false);
    setShowSuccessMessage('');
  };

  const handleLogoutFromCalendly = async () => {
    try {
      if (currentUser?.id) {
        const response = await logoutFromCalendly(currentUser?.id);
        if (response?.status === 200) {
          fetchUserData();
          setShowConfirmCalendlyLogoutModal(false);
          setShowSuccessMessage('Calendly account disconnected successfully');
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="d-flex-row w-100 mt-1rem mb-2_25rem">
        <div className="d-flex-start-start pr-1rem">
          <span className="fw-600 c-111928 fs-1_125rem lh-1_125rem ff-poppins mb-0_5rem">
            Linked Calendars
          </span>
          <span className="c-6b7280 ff-inter">
            Connect the calendar you use in everyday life
          </span>
        </div>
        <div className="d-flex-row-space-between w-100">
          <div className="d-flex-row-space-between bg-white h-5_125rem w-100 b-radius-0_5rem b-1 p-1rem">
            <div className="d-flex-start-start ">
              <div className="d-flex-center mb-0_5rem">
                <CalendlyIcon />
              </div>
              <span className="ff-inter c-6b7280 fs-0_875rem">
                Link Calendly to your dashboard for easy appointment management.
              </span>
            </div>
            <div className="d-flex-center">
              {currentUser?.isCalendlyLoginIn ? (
                <button
                  className="btn-disconnect w-7rem"
                  onClick={handleOpenCalendlyLogoutModal}
                >
                  Disconnect
                </button>
              ) : (
                <button
                  className="btn-agent-bio-save w-7rem"
                  onClick={handleIntegrationToCalendly}
                >
                  Connect
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {showConfirmCalendlyLogoutModal && (
        <div className="d-flex-center p-fixed bg-modal top-0 left-0 size-max z4">
          <ConfirmModal
            title="Are you sure you want to remove your Calendly account connection?"
            onConfirm={handleLogoutFromCalendly}
            onCancel={handleCloseCalendlyLogoutModal}
          />
        </div>
      )}
      {showSuccessMessage && (
        <div className="d-flex-center p-fixed bg-modal top-0 left-0 size-max z4">
          <InfoModal
            title={showSuccessMessage}
            onClose={handleCloseSuccessModal}
          />
        </div>
      )}
    </>
  );
};

export default CalendarHeader;
